// Questions fréquentes affichées sur /maprimeadapt. Ce tableau alimente à la
// fois l'affichage et le balisage FAQPage : les deux doivent rester identiques,
// Google exige que les questions déclarées soient visibles sur la page.
//
// Règle de conformité (courrier ANAH) : 22 000 € est un plafond de TRAVAUX,
// l'aide maximale est de 15 400 € (70 %) ou 11 000 € (50 %). Aucun partenariat
// France Rénov' ne doit être revendiqué.

export const faqMaPrimeAdapt = [
  {
    id: "eligibilite-idf",
    question: "Suis-je éligible à MaPrimeAdapt' en Île-de-France ?",
    answer:
      "Vous êtes éligible si vous avez 70 ans ou plus, ou de 60 à 69 ans avec une perte d'autonomie classée GIR 1 à 6, ou si vous êtes en situation de handicap avec un taux d'incapacité d'au moins 50 %, l'AAH ou la PCH. S'y ajoute une condition de ressources — ménage modeste ou très modeste selon les barèmes de l'ANAH, plus élevés en Île-de-France — et le logement doit être votre résidence principale.",
  },
  {
    id: "definition",
    question: "Qu'est-ce que MaPrimeAdapt' exactement ?",
    answer:
      "MaPrimeAdapt' est l'aide de l'ANAH qui finance l'adaptation du logement au vieillissement et au handicap. Entrée en vigueur en 2024, elle a remplacé et regroupé plusieurs dispositifs antérieurs, dont l'aide « Habiter Facile » de l'ANAH et le crédit d'impôt autonomie. Elle finance les travaux mais aussi l'accompagnement obligatoire par un assistant à maîtrise d'ouvrage.",
  },
  {
    id: "amo-obligatoire",
    question: "L'accompagnement par un AMO est-il obligatoire ?",
    answer:
      "Oui. Le recours à un assistant à maîtrise d'ouvrage (AMO) est une condition pour obtenir MaPrimeAdapt'. L'AMO organise la visite d'évaluation à votre domicile, monte le dossier, le dépose auprès de l'ANAH et suit le chantier jusqu'au versement des aides. Son coût est pris en charge par l'ANAH : 600 € dans le cas général, 800 € pour les personnes de plus de 80 ans ou ayant subi une chute récente.",
  },
  {
    id: "cout-amo",
    question: "Combien me coûte l'accompagnement AMO au final ?",
    answer:
      "Rien. La somme est avancée puis remboursée par l'ANAH en même temps que les aides travaux. Nous ne prenons aucune commission sur les devis des artisans, et notre rémunération vient exclusivement de cette prise en charge.",
  },
  {
    id: "travaux-eligibles",
    question: "Quels travaux sont éligibles à MaPrimeAdapt' ?",
    answer:
      "Les travaux qui sécurisent le logement et facilitent la vie quotidienne : remplacement d'une baignoire par une douche de plain-pied, sol antidérapant, barres d'appui, siège de douche, WC surélevé, monte-escalier, élargissement de portes, suppression de seuils, main courante, éclairage adapté, volets roulants électriques, rampe d'accès et cheminement extérieur. Les travaux de confort sans lien avec l'autonomie ne sont pas retenus.",
  },
  {
    id: "montant-plafond",
    question: "Quel est le montant maximum de l'aide ?",
    answer:
      "MaPrimeAdapt' prend en charge 70 % du montant des travaux pour les ménages aux ressources très modestes et 50 % pour les ménages modestes. Les travaux retenus sont plafonnés à 22 000 € hors taxes : l'aide atteint donc au maximum 15 400 € à 70 %, et 11 000 € à 50 %. Ce plafond de travaux s'apprécie sur une période de cinq ans, par bénéficiaire et par logement.",
  },
  {
    id: "ressources",
    question: "Quelles sont les conditions de ressources ?",
    answer:
      "Il faut appartenir à la catégorie « ressources modestes » ou « très modestes » de l'ANAH. Les plafonds dépendent du nombre de personnes composant le foyer et sont plus élevés en Île-de-France qu'ailleurs. Ils sont revalorisés chaque année : nous vérifions votre situation sur le barème en vigueur au moment du dépôt, à partir de votre revenu fiscal de référence.",
  },
  {
    id: "avance",
    question: "Dois-je avancer l'argent des travaux ?",
    answer:
      "Une avance sur l'aide peut être demandée à l'ANAH selon votre situation, ce qui évite d'avoir à débourser la totalité du chantier. Nous la sollicitons systématiquement lorsque votre profil le permet, et nous organisons le calendrier de paiement avec les artisans en conséquence.",
  },
  {
    id: "diagnostic",
    question: "En quoi consiste la visite d'évaluation à domicile ?",
    answer:
      "Un professionnel se déplace chez vous pour réaliser un diagnostic autonomie. Il observe les gestes du quotidien — se laver, se déplacer, cuisiner, accéder au logement — et identifie les obstacles concrets. Son rapport liste les adaptations à prévoir et sert de base au dossier. Un ergothérapeute peut intervenir en complément lorsque la situation le justifie.",
  },
  {
    id: "delais",
    question: "Combien de temps faut-il compter au total ?",
    answer:
      "Comptez généralement trois à six mois entre le premier contact et la fin des travaux : environ un mois pour constituer le dossier, deux à trois mois d'instruction par l'ANAH, puis un à deux mois de chantier. Le versement des aides intervient après réception des travaux et vérification des factures.",
  },
  {
    id: "avant-accord",
    question: "Puis-je commencer les travaux avant l'accord de l'ANAH ?",
    answer:
      "Non, et c'est l'erreur la plus coûteuse. Des travaux démarrés avant l'accord de l'ANAH ne sont pas finançables, même si le dossier aurait été accepté. Attendez la notification avant de laisser un artisan intervenir.",
  },
  {
    id: "artisan",
    question: "Puis-je choisir mon propre artisan ?",
    answer:
      "Oui, vous restez libre du choix de l'entreprise. Nous vérifions simplement que les devis sont conformes aux exigences de l'ANAH et correspondent aux préconisations du diagnostic. Si vous le souhaitez, nous vous mettons en relation avec des artisans de notre réseau, sans obligation ni surcoût.",
  },
  {
    id: "cumul",
    question: "MaPrimeAdapt' se cumule-t-elle avec d'autres aides ?",
    answer:
      "Oui. Elle se cumule notamment avec les aides des caisses de retraite (CARSAT, MSA), celles des collectivités d'Île-de-France, la prestation de compensation du handicap (PCH) et l'allocation personnalisée d'autonomie (APA). C'est ce cumul qui fait réellement baisser le reste à charge, et nous recherchons systématiquement les aides mobilisables dans votre commune et votre département.",
  },
  {
    id: "pch",
    question: "Quelle différence entre MaPrimeAdapt' et la PCH ?",
    answer:
      "La PCH est versée par la MDPH au titre de la compensation du handicap, sans condition de ressources pour l'accès au droit, tandis que MaPrimeAdapt' est une aide de l'ANAH soumise à plafonds de ressources. Les deux répondent à des logiques différentes et peuvent se compléter sur un même projet d'adaptation.",
  },
  {
    id: "locataire",
    question: "Je suis locataire, puis-je en bénéficier ?",
    answer:
      "MaPrimeAdapt' concerne les résidences principales et s'adresse en premier lieu aux propriétaires occupants. Un locataire du parc privé peut être concerné avec l'accord écrit de son propriétaire. Les logements sociaux relèvent d'autres dispositifs. Dites-nous votre situation, nous vous orientons vers l'aide adaptée.",
  },
  {
    id: "parent-heberge",
    question: "Mon parent vit chez moi, peut-il en bénéficier ?",
    answer:
      "L'aide porte sur le logement qui constitue la résidence principale du bénéficiaire. Si votre parent est hébergé chez vous, c'est votre situation de propriétaire et les revenus de l'ensemble du foyer qui sont examinés — l'ANAH prend en compte les revenus de tous les occupants, y compris ceux hébergés à titre gratuit. Nous étudions ce cas de figure au cas par cas.",
  },
  {
    id: "revente",
    question: "Que se passe-t-il si je vends mon logement après les travaux ?",
    answer:
      "Les aides de l'ANAH sont assorties d'un engagement d'occupation du logement à titre de résidence principale, dont la durée figure dans la notification d'attribution. Une revente avant ce terme peut donner lieu à un remboursement partiel. Nous vous indiquons la durée applicable à votre dossier avant que vous ne vous engagiez.",
  },
  {
    id: "imposable",
    question: "L'aide est-elle imposable ?",
    answer:
      "Les aides versées par l'ANAH ne constituent pas un revenu imposable et n'ont pas à être déclarées comme tel. En revanche, elles sont déduites de la base des travaux si vous mobilisez par ailleurs un dispositif fiscal sur le même chantier.",
  },
  {
    id: "changement-2026",
    question: "Qu'est-ce qui change au 17 août 2026 ?",
    answer:
      "MaPrimeRénov', Mon Projet Anah et France Rénov' fusionnent au sein d'un compte personnel unique, hébergé sur france-renov.gouv.fr et sécurisé par FranceConnect+. Les trois plateformes sont fermées du 3 au 17 août 2026 : aucun compte ne peut être créé ni aucun dossier déposé pendant cette période. Les montants d'aide, les plafonds de ressources et les critères d'éligibilité ne sont pas modifiés par cette migration.",
  },
];
